<ng-container *transloco="let t" class="container">
  <div class="p-2">
    <div class="modal-header">
      <h5 class="modal-title">{{ title }}</h5>
      <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
      </button>
    </div>
    <form [formGroup]="inputForm">
      <div class="modal-body">
        <app-input formControlName="email" label="app.common.user.email"/>
        @if (!isAdmin) {
          <app-select formControlName="role" [items]="[organizerRoleId, helperRoleId]" [labels]="['app.common.user.role.' + organizerRoleId,
       'app.common.user.role.' + helperRoleId]" label="app.common.user.role"/>
        }
      </div>
    </form>
    <div class="modal-footer">
      <div class="d-flex justify-content-end">
        <div class="me-3">
          <app-button (onClick)="onDismissClick()" [label]="dismissButtonTitle ?? t('app.common.cancel')"
                      [btnClass]="'btn-grey text-uppercase'"></app-button>
        </div>
        <app-button (onClick)="onConfirmClick()" [label]="confirmButtonTitle ?? t('app.common.confirm')"
                    [btnClass]="'btn-primary-red text-uppercase'"
                    [isDisabled]="!inputForm.valid"></app-button>
      </div>
    </div>
  </div>
</ng-container>
